/*============================================================================
	Gallery section
==============================================================================*/

var gallery = {
  init: function () {
    $('.gallery-horizontal')
      .find('.gallery-image-wrapper')
      .each(function () {
        var wrapper = $(this);
        var images = $(this).find('img');
        var imgWidth, imgHeight;

        $('<img />')
          .attr('src', $(images).attr('src'))
          .on('load', function () {
            imgWidth = this.width;
            imgHeight = this.height;

            $(wrapper).css('flex-basis', (imgWidth * 200) / imgHeight);
            $(wrapper).css('flex-grow', (imgWidth * 200) / imgHeight);
            $(wrapper)
              .find('i')
              .css('padding-bottom', (imgHeight / imgWidth) * 100 + '%');
          });
      });

    //initialize lightbox
    // lightboxGallery.init();
    // magnificPopupGallery.init();
  },
};

$(document).ready(function ($) {
  gallery.init();

  function openPhotoHandler(e) {
    e.preventDefault();

    setTimeout(() => {
      var img = document.querySelectorAll('.mfp-zoom-in .mfp-content');
      var closeBtn = document.querySelector('.mfp-zoom-in .mfp-content .mfp-close');

      function touchstart(e) {
        e.preventDefault();
        $('.mfp-bottom-bar').toggle();
      }

      img.forEach((item) => {
        item.addEventListener('touchstart', touchstart, false);
      });

      closeBtn.addEventListener(
        'touchstart',
        function (e) {
          $(this).trigger('click');
        },
        false
      );
    }, 500);
  }

  $('a.lightbox').on('click', function (e) {
    if (document.readyState === 'complete') {
      openPhotoHandler(e);
    } else {
      console.log('ready state click error');
      e.preventDefault();
      return false;
    }
  });

  function initMagnific() {
    $('a.lightbox').magnificPopup({
      mainClass: 'mfp-zoom-in mfp-img-mobile',
      type: 'image',
      tLoading: '',
      gallery: {
        enabled: true,
      },
      removalDelay: 300,
      callbacks: {
        beforeChange: function () {
          this.items[0].src = this.items[0].src + '?=' + Math.random();
        },
        open: function () {
          $.magnificPopup.instance.next = function () {
            var self = this;
            self.wrap.removeClass('mfp-image-loaded');
            setTimeout(function () {
              $.magnificPopup.proto.next.call(self);
            }, 120);
          };
          $.magnificPopup.instance.prev = function () {
            var self = this;
            self.wrap.removeClass('mfp-image-loaded');
            setTimeout(function () {
              $.magnificPopup.proto.prev.call(self);
            }, 120);
          };
        },
        imageLoadComplete: function () {
          var self = this;
          setTimeout(function () {
            self.wrap.addClass('mfp-image-loaded');
          }, 16);
        },
        change: function () {},
      },
    });
  }

  $(window).on('load', function () {
    $.noConflict();
    initMagnific();
    console.log("should see this")
  });
  
  $(document).on('shopify:section:load', function (e) {
    console.log("shopify:section:load")
    initMagnific();
    gallery.init();
  });

});
